export type CurrencySeparator = "comma" | "space";

/**
 * Raqamli summani guruhlangan pul satriga aylantiradi, kasr qismini tashlab
 * yuboradi. Minglar ajratgichi standart holda vergul (`1,234,567`), uni
 * probelga (`1 234 567`) almashtirsa bo'ladi.
 */
export function formatCurrency(
  value: number | null | undefined,
  separator: CurrencySeparator = "comma",
): string {
  if (value == null || Number.isNaN(value)) return "0";

  const grouped = Math.trunc(value).toLocaleString("en-US");

  return separator === "space" ? grouped.replaceAll(",", " ") : grouped;
}
